<div class="welcome-screen">
    <div>
        <img src="assets/images/gnvert-style/logo_engie-solutions.svg">
    </div>
    <div class="welcome-title" [translate]="'home.gnvert.welcome'"></div>
    <div class="welcome-text" [translate]="'home.gnvert.welcomeText'"></div>
    <div class="welcome-text version-container">{{ VERSION }}</div>
</div>
